<nav class="toolbar navbar navbar-light">
    <form class="form-inline" autocomplete="off">
        <button *ngIf="allowNuevaSolicitud" class="btn btn-outline-success" type="button" (click)="onAdd()" title="Nueva">
            <i class="fa fa-file-o"></i> Nueva
        </button>
        <button type="button" class="btn btn-outline-success" [disabled]="!exportIsAvailable" (click)="onExportExcel()" title="Exportar">
            <i class="fa fa-file-excel-o"></i> Exportar
        </button>
        <button *ngIf="spinnerExport && !searching" type="button" [disabled]="true" class="btn btn-outline-success">
            <p-progressSpinner class="spinnerExcel"></p-progressSpinner>
            Exportando
        </button>
        <div *ngIf="isOperadorCam" class="nota-info">
            <label class="col-form-label" for=""><i class="fa fa-info-circle" aria-hidden="true"></i> El borrado de una solicitud implica desvincular sus recintos <u class="shadow" ngbTooltip="PIAEd = Parcela-Invernadero-Almacén-Empresa Deshidratadora" placement="bottom">"PIAEd"</u> y eliminar los documentos.</label>
        </div>
    </form>
</nav>

<div class="container-fluid container-list">

    <app-buscador-solicitudcam-filter [lastFilter]="payload" [campanias]="campanias"
                                      [periodos]="periodos" [CAs]="CAs" [tiposSolicitud]="tiposSolicitud" [estadosSolicitud]="estadosSolicitud" [EAs]="EAs"
                                      (search)="onSearch($event)" (cleanForm)="onReset()" (campaniaSelected)="onCampaniaSelected($event)"
                                      (activaSelected)="onActivaSelected($event)" (periodoSelected)="onPeriodoSelected($event)" (caSelected)="onCASelected($event)">
    </app-buscador-solicitudcam-filter>

    <app-buscador-solicitudcam-list *ngIf="searching"
                                    [result]="result" [lastFilter]="payload" [userData]="userData"
                                    (search)="onSearchLazy($event)" (edit)="onEdit($event)" (view)="onView($event)" (delete)="onDelete($event)">
    </app-buscador-solicitudcam-list>
</div>
